<!-- Translated: skip -->
<template>
  <div>
    <div :class="{banner: true, quick: quick}">
      <h1>LIFTKORT OCH KEYCARD</h1>

      <img class="badge" v-if="SITE_CONFIG.site === 'branas' || SITE_CONFIG.site === 'branas'" src="https://static.booking.branasgruppen.se/static/img/badge-lifkort.png" />
    </div>
    <div class="content">

      <div class="info center">

        <div class="box">
          <div class="img">
          </div>
          <div class="content">
            <h2 style="text-align:left;" v-if="SITE_CONFIG.skipass.day_online && SITE_CONFIG.skipass.season_online">Liftkort och säsongskort</h2>
            <h2 style="text-align:left;" v-if="SITE_CONFIG.skipass.day_online && !SITE_CONFIG.skipass.season_online">Liftkort</h2>
            <h2 style="text-align:left;" v-if="!SITE_CONFIG.skipass.day_online && SITE_CONFIG.skipass.season_online">Säsongskort</h2>

            <ul>
              <!--<li>Liftkort levererat till stugan</li>-->
              <li>Slipp köer och åk direkt ut i backen</li>
              <!--<li>Gratis keycard ord pris (55:-/st)</li>-->
            </ul>

            <button class="small" v-if="SITE_CONFIG.skipass.buy_enabled && SITE_CONFIG.skipass.load_enabled" @click="open()">Ladda och köp</button>
            <button class="small" v-if="SITE_CONFIG.skipass.buy_enabled && !SITE_CONFIG.skipass.load_enabled" @click="open()">
              <span v-if="!SITE_CONFIG.skipass.day_online && SITE_CONFIG.skipass.season_online">Köp säsongskort</span>
              <span v-else>Köp liftkort</span>
            </button>

            <button class="small" v-if="!SITE_CONFIG.skipass.buy_enabled" @click="open('SkiPassPickDateKeycard')">Köp laddningsbart liftkort</button>

            <button class="small" v-if="!SITE_CONFIG.skipass.buy_enabled && SITE_CONFIG.skipass.load_enabled" @click="open()">Ladda liftkort</button>
            <button class="small" v-if="SITE_CONFIG.skipass.buy_enabled && !SITE_CONFIG.skipass.load_enabled" @click="goToLoading()">Ladda liftkort</button>
            <button class="small" v-if="SITE_CONFIG.skipass.buy_enabled && SITE_CONFIG.skipass.load_enabled" @click="goToLoading()">Bara ladda</button>
          </div>
        </div>
        <!--
        <div class="info">
          <p class="ingress">Köper du våra periodkort får du alltid förmånliga priser. Köper du våra periodkort får du alltid förmånliga priser sön-tors, tors-sönd och sön-sön.</p>

          <h2>LADDA LIFTKORT</h2>
          <p>Har ni redan befintliga keycard hemma? Ladda korten enkelt via ”Ladda liftkort” nedan. Liftkortet kan användas när som helst under säsongen och aktiveras när du använder det första gången.</p>
          <p>”Ladda liftkort” öppnar under hösten 2017, önskar ni ladda era keycard redan nu ring oss på 054-13 26 00 eller klicka er in på vår onlinebokning.</p>
          <p>1. Ladda ditt keycard med önskat antal åkdagar.</p>
          <p>2. Betala med kort eller via Swish.</p>
          <p>3. Nu är det bara att åka!</p>
        </div>

        <h2>FAQ</h2>

        <div class="padded">

          <div v-for="({question, answer}, index) in faqs" :key="question" class="items-list">
            <Collapsable :title="question" :content="answer" />
          </div>
        </div>
      -->

      </div>

      <!--
      <div class="info">
        <h2>GRATIS FÖR BARN</h2>
        <p>I Branäs är alla aktiviteter gratis för barn med liftkort. Är barnen under åtta år bjuder vi dessutom på liftkortet. Men glöm inte att barnen behöver ett eget keycard som kostar 55kr, läs mer om liftkort och keycard under boxen ”Så fungerar det med liftkort” här ovanför.
        <br>För lite extra energipåfyllning ute i backen bjuder vi alla barn på varm ekologisk saft.</p>
      </div>
      -->

      <div class="info-content" v-html="pageContent">
      </div>

    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Collapsable from '@/components/components/Collapsable';

import Page from '@/components/parts/Skipass/Page';

import API from '@/classes/API';

export default {
  components: {
    Collapsable,
    Page,
  },
  data() {
    return {
      expanded: [],
      quick: false,
      faqs: [
        {
          question: 'Så fungerar det med liftkort',
          answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        },
        {
          question: 'Här köper du liftkort',
          answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        },
        {
          question: 'Tips - undvik köer, köp dina liftkort på webben!',
          answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        },
      ],
      pageContent: '',
    };
  },
  computed: {
    ...mapGetters([
      'guidedPasses',
    ]),
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
    ]),
    open(modal) {
      this.doTheOpening(modal);
    },
    goToLoading() {
      window.location.href = this.SITE_CONFIG.skipass.load_url;
    },
    doTheOpening(modal) {
      /* if (this.guidedPasses.length) {
        const $this = this;
        this.openModal(['GeneralModal', {
          title: 'En omgång liftkort',
          content: '<p>För tillfället går det endast att lägga på
          en omgång med liftkort.</p><p>Vill du se över vad du redan bokat?</p>',
          buttons: [
            {
              title: 'Avrbyt',
              class: 'border small white',
              click: () => {
                $this.closeModal();
              },
            },
            {
              title: 'Ändra nuvarande bokning',
              class: 'border small',
              click: () => {
                $this.closeModal();
                $this.$router.push({ name: 'ski pass overview' });
              },
            },
            {
              title: 'Ta bort tidigare bokning och gör om',
              class: 'border small white',
              click: () => {
                $this.closeModal();
                $this.openModal(['SkiPassPickDate']);
              },
            },
          ],
        }]);
      } else { */
      if (modal) {
        this.openModal([modal]);
        return;
      }

      if (this.$route.query.onlykeycard) {
        this.openModal(['SkiPassPickDateKeycard']);
      } else {
        this.openModal(['SkiPassPickDate']);
      }
      // }
    },
  },
  async mounted() {
    const response = await API.get('page/skipass');
    this.pageContent = response;

    if (this.$route.query.quick) {
      setTimeout(this.doTheOpening, 1);
      this.quick = true;
    }
  },
};
</script>

<style lang="stylus">
body
  background-color white
</style>

<style scoped lang="stylus">
@import '~@/global.styl'

.banner.quick
  height 100vh
  background-size cover
  background-image url(https://static.booking.branasgruppen.se/static/img/onsite-splash.jpg)
  background-position center
  position relative
  padding 0
  & > *
    display: none

.banner
  height 423px
  background-size cover
  background-image url(https://static.booking.branasgruppen.se/static/img/Branas_funpark-liftkort.jpg)
  background-position center
  position relative
  padding 0
  +max-mobile()
    height 180px

  .badge
    position: absolute;
    right 100px
    bottom -space-3
    width 173px
    height 173px
    +max-screen(1300px)
      bottom space-2
      right 15px
    +max-mobile()
      width 90px
      height 90px
      right 15px
      bottom space-3

  h1
    position absolute
    bottom 0
    left calc(50% - 300px)
    width 600px
    max-width 100%
    padding 15px 5px
    margin-bottom 0
    background-color rgba(255, 255, 255, 0.92)
    united-heavy()
    uppercase()
    centered()
    font-size size-font-headline
    color brick
    +max-screen(600px)
      _padding = padding-mobile
      left _padding
      width "calc(100% - %s)" % (_padding * 2)
    +max-mobile()
      font-size size-font-headline-mobile

.ingress
  max-width 674px
  font-size 17px
  font-weight bold
  margin 25px auto
  text-align center
  +max-mobile()
    text-align left
    padding padding-mobile
    font-size 15px
    margin-top 0
    margin-bottom: 5px

.info
  max-width 980px
  margin 60px auto 35px auto
  +max-mobile()
    padding 0 padding-mobile
    margin-top 0
  h2
    united-heavy()
    uppercase()
    centered()
    font-size size-font-headline
    color #262626
    font-size size-font-headline-small
    margin-top 45px
    margin-bottom 20px
    +max-mobile()
      font-size: 18px
    &:before
      display none
  p
    font-size size-font-3
    max-width 656px
    margin 0 auto
    margin-bottom 1em
    text-align: left
  .padded
    max-width 656px
    margin 0 auto

.box
  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.13);
  padding space-2
  display: flex
  cursor pointer
  margin-top: 20px
  button
    margin-right 25px
    margin-bottom 22px
  +max-mobile()
    flex-wrap wrap
    padding: 8px 8px 15px
  .img
    background-image: url(https://static.booking.branasgruppen.se/static/img/kort-lifkort.jpg);
    background-size: cover;
    height 210px
    width 279px
    +max-mobile()
      width 100%
      height 150px
      display: none
  & > *
    margin-right space-3
    text-align: left
    +max-mobile()
      margin-right 0
  .content
    +max-mobile()
      width 100%
      padding-left 20px
      padding-right 20px
    h2
      margin-top space-2
      +max-mobile()
        margin-bottom 5px
        margin-top: 8px
    button
      +max-mobile()
        width 100%

ul
  margin-top 10px
  margin-bottom 10px
  padding-left: 20px
  li
    list-style disc
    margin-bottom 10px
    font-size 14px
    font-weight 300
    list-style-image url(https://static.booking.branasgruppen.se/static/svg/punklista-check.svg)
</style>



// WEBPACK FOOTER //
// SkiPassPage.vue?a22c2dfc